
class AreaModel {
    id: number;
    title: string;
    pId: number;
    isActive: boolean;

    constructor(
        id: number,
        title: string,
        pId: number,
        isActive: boolean,
    ) {
        this.id = id;
        this.title = title;
        this.pId = pId;
        this.isActive = isActive;
    }

    public static fromJson(json: any): AreaModel {
        return new AreaModel(
            json["id"],
            json["title"],
            json["pId"],
            json["isActive"],
        );
    }
}


export interface AreaGetPayloadFilterModel {
    id?: number;
    title?: string;
    pId?: number;
    isActive?: number;
}

export interface AreaGetPayloadModel {
    pageSize?: number;
    pageNumber?: number;
    Filters?: AreaGetPayloadFilterModel;
}


export interface AreaPayloadModel {
    id: number;
    title: string;
    pId: number;
    isActive: boolean;

}
export default AreaModel;
